// @pixi/react v8 requires every PIXI class used as a JSX element to be
// registered with the reconciler via `extend()`. Without this call,
// `<pixiGraphics>` / `<pixiSprite>` / etc. throw at render time:
//   "Graphics is not part of the PIXI namespace! Did you forget to extend?"
//
// This module is a side-effect import (imported once at app boot, before any
// pixi-react component mounts). The set below is exhaustive against the JSX
// elements used in src/game/**; add new entries here when introducing a new
// pixi-react JSX tag elsewhere.

import { extend } from '@pixi/react'
import { Container, Graphics, Sprite, Text } from 'pixi.js'

extend({ Container, Graphics, Sprite, Text })
